export const SHOPIFY_URL = 'https://admin.shopify.com/store/<shopify_store_name>/online_store/preferences';
